import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { bookingAPI } from '../../api/bookings';

const BookingTrends = ({ businessId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (businessId) {
      loadTrends();
    }
  }, [businessId]);

  const loadTrends = async () => {
    try {
      // Mock data - in production, fetch from API
      setData([
        { day: 'Mon', bookings: 12 },
        { day: 'Tue', bookings: 18 },
        { day: 'Wed', bookings: 15 },
        { day: 'Thu', bookings: 22 },
        { day: 'Fri', bookings: 28 },
        { day: 'Sat', bookings: 35 },
        { day: 'Sun', bookings: 20 },
      ]);
    } catch (error) {
      console.error('Failed to load trends:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-4">Loading trends...</div>;

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-lg font-semibold mb-4">Weekly Booking Trends</h2>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="day" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="bookings" stroke="#3b82f6" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BookingTrends;